<template>
<h4 class="text-primary font-semibold mt-3 mb-2">
<template v-if="loading">
	<i class="pi pi-spin pi-spinner text-primary" style="font-size: 1em"></i>
</template>
<template v-else>
	<template v-if="resolved_data">
		{{ $filters.numberformat( resolved_data)}}
	</template>
	<template v-else>
		-
	</template>
</template>
	
</h4>
</template>

<script>
export default {

  name: 'ColumnCalculation',
  props:["data"],
  data () {
    return {
    	nodes:[],
    	connections:[],
    	loading:true,
    	resolved_data:null,
    }
  },
  computed:{
  	 inputfields_updating()
  	{
  		return this.$store.state.evaluation.inputfields_updating
  	},
  },
  watch:{
  	inputfields_updating(newval,oldval)
  	{
  		if(!newval)
  		{
  			
  			this.resolveAll()
  		}
  	}
  },
  async mounted()
  {
  	this.resolveAll()
  },
  methods:{
  	async resolveAll()
  	{
  		let data =  await this.resolveData()
	  	
	  	if(this.data)
	  	{
	  		this.resolved_data =  await parseFloat(data.toFixed(5));
	  	}
	  	
	  	this.loading =  await false
  	},
  	async resolveData()
  	{
  		this.loading = true
  		let output
  		let calculation = JSON.parse(this.data.calculation)  		
  		//console.log(calculation)
  		this.nodes = calculation.nodes
  		this.connections = calculation.connections
  		let equation = this.nodes.find((item)=>{return item.type=="equation"})
  		if(equation)
  		{
  			let equation_connection = this.connections.find((item)=>{return item.to == equation.id})
	  		if(equation_connection)
	  		{
	  			let last_operation = this.nodes.find((item)=>{return item.id == equation_connection.from})
	  			output = await this.getOperatorNodeOutput(last_operation)
	  			
	  		}
  		}
  		return await output
  		
  		
  	},
  	async getOperatorNodeOutput(operator)
  	{
  		let node_input_1 = operator.input1
  		let node_input_2 = operator.input2
  		let node_input_1_value
  		let node_input_2_value
  		let output
  		//get input 1 value
  		if(node_input_1)
  		{
  			if(node_input_1.type=="value")
  			{
  				node_input_1_value = node_input_1.value
  			}
  			if(node_input_1.type=="connection")
  			{
  				let connection = this.connections.find((item)=>{return item.id == node_input_1.connection_id})
  				let input_node = this.nodes.find((item)=>{return item.id == connection.from})
  				node_input_1_value = await this.getNodeOutput(input_node)
  			}

  		}
  		//get input 1 value


  		//get input 2 value
  		if(node_input_2)
  		{
  			if(node_input_2.type=="value")
  			{
  				node_input_2_value = node_input_2.value
  			}
  			if(node_input_2.type=="connection")
  			{
  				let connection = this.connections.find((item)=>{return item.id == node_input_2.connection_id})
  				let input_node = this.nodes.find((item)=>{return item.id == connection.from})
  				node_input_2_value = await this.getNodeOutput(input_node)
  			}
  		}
  		//get input 2 value
  		node_input_1_value = parseFloat(node_input_1_value)
  		node_input_2_value = parseFloat(node_input_2_value)

  		if(operator.type=="addition")
  		{
  			if(!node_input_1_value)
  			{
  				node_input_1_value = 0
  			}
  			if(!node_input_2_value)
  			{
  				node_input_2_value = 0
  			}
  			output = node_input_1_value+node_input_2_value
  		}

  		if(operator.type=="subtraction")
  		{
  			if(!node_input_1_value)
  			{
  				node_input_1_value = 0
  			}
  			if(!node_input_2_value)
  			{
  				node_input_2_value = 0
  			}
  			output = node_input_1_value-node_input_2_value
  		}

  		if(operator.type=="multiplication")
  		{
  			if(!node_input_1_value)
  			{
  				node_input_1_value = 1
  			}
  			if(!node_input_2_value)
  			{
  				node_input_2_value = 1
  			}
  			output = node_input_1_value*node_input_2_value
  		}

  		if(operator.type=="division")
  		{
  			if(!node_input_1_value)
  			{
  				node_input_1_value = 1
  			}
  			if(!node_input_2_value)
  			{
  				node_input_2_value = 1
  			}
  			output = node_input_1_value/node_input_2_value
  		}
  		return await output
  	},
  	async getNodeOutput(input_node)
  	{
  		
  		let output = null
  		if(input_node.type=="variable")
  		{
  			let inputfield_submission = await  this.silentApiGet("get_inputfield_submission/"+input_node.inputfield_id)   			
  			if(inputfield_submission && inputfield_submission.inputfield.type=="columns")
  			{
  				let columns_data = JSON.parse(inputfield_submission.submission_text)
  				let the_column = columns_data.find((item)=>{return item.id == input_node.column_id})
  				if(the_column && the_column.value)
  				{
  					if(inputfield_submission.is_nulled)
  					{
  						output = null
  					}
  					else
  					{
  						output = the_column.value
  					}
  					
  				}
  				else
  				{
  					output = null
  				}
  			}
  			else if(inputfield_submission && inputfield_submission.inputfield.type=="number")
  			{
  				if(inputfield_submission.submission_numerical)
  				{
  					output = inputfield_submission.submission_numerical
  				}
  				else
  				{
  					output = null
  				}
  				
  			}
  			else
  			{
  				output = null
  			}
  		}

  		if(input_node.type!=="variable")
  		{
  			output = this.getOperatorNodeOutput(input_node)
  		}

  		return await output
  	},
  }
}
</script>

<style lang="css" scoped>
</style>